/**
 * An optimized P1 component.
 *
 * @param props
 * @returns p
 */
export const P1: React.FC<JSX.IntrinsicElements["p"]> = (props) => {
  return (
    <p
      {...props}
      className={`text-base ${props.className}`}
    >
      {props.children}
    </p>
  )
}
